<hr class="qvs-login-page-header__divider" />
<h1 class="qvs-login-page-header__title">
  {{ title | translate }}
</h1>
